import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/database'

import utils from './utils'


const state = () => ({
  /**
   * ユーザID (Firebase 発番の uid)
   */
  uid: '',

  /**
   * ユーザ名（表示用）
   */
  name: '',

  /**
   * ユーザのメアド
   */
  mail: '',

  /**
   * Firebase に格納されているアイテム情報（所持数情報）
   * Firebase 発番の文字列をキーにした連想配列の形をとる。
   * @type {{[key: string]: Object}}
   */
  items: {},
})


const getters = {
  /**
   * ユーザがログイン状態なら true
   * @param {{[key:string]: any}} state
   * @return {boolean}
   */
  isLoggedIn (state) {
    return !!state.uid
  },
}


const actions = {
  /**
   * ユーザのログイン状態の変化をステートへ反映するべく、監視を開始する
   * @param {Context} context    Vuex コンテキスト { state, rootState, getters, rootGetters, dispatch, commit }
   */
  watchUserAuthStateChange ({ commit }) {
    firebase.auth().onAuthStateChanged(user => {
      const uid  = user ? user.uid : ''
      const name = user ? 'さとみん'              : ''  // TODO: 表示名を正しいものにする
      const mail = user ? 'puri-puri@example.com' : ''  // TODO: メアドを正しいものにする

      // ログアウト状態になった場合
      if (!user) {
        commit('reset')
      }

      // ログイン状態になった場合
      else {
        commit('update', { uid, name, mail })

        firebase.database().ref(`users/${uid}`).update({ name, mail })
        firebase.database().ref(`users/${uid}/items`).on('value', snapshot => {
          const items = snapshot.val() || {}
          commit('update', { items })
        })
      }
    })
  },

  /**
   * ユーザをログイン状態にする
   * @param {Context} _context    Vuex コンテキスト { state, rootState, getters, rootGetters, dispatch, commit }
   * @param {{ username:string, password:string }} payload    メールアドレス＆パスワード認証用
   */
  login (_context, payload = {}) {
    const { username, password } = payload

    // 以下が成功すると onAuthStateChanged() が呼ばれ、それによりステート情報は変化する。
    firebase.auth().signInWithEmailAndPassword(username, password)
      .catch(error => {
        // TODO: 仮。とりあえずわかるようにする
        console.error(error)  // eslint-disable-line no-console
        alert(error.message)
      })
  },

  /**
   * ユーザをログアウト状態にする
   */
  logout () {
    // 以下が成功すると onAuthStateChanged() が呼ばれ、それによりステート情報は変化する。
    firebase.auth().signOut()
  },

  updateStoredItem ({ state }, item = {}) {
    const id  = item.id
    const uid = state.uid
    if (id && uid) {
      const isProcured   = !!item.isProcured
      const isRecruiting = !!item.isRecruiting
      const numOwned     = item.numOwned    || { usual: 0, kira: 0 }
      const numReleased  = item.numReleased || { usual: 0, kira: 0 }
      numOwned.usual     = Math.max(0, numOwned.usual   ) || 0
      numOwned.kira      = Math.max(0, numOwned.kira    ) || 0
      numReleased.usual  = Math.max(0, numReleased.usual) || 0
      numReleased.kira   = Math.max(0, numReleased.kira ) || 0
      firebase.database().ref(`users/${uid}/items/${id}`).update({ id, numOwned, numReleased, isProcured, isRecruiting })
    }
  },

  updateStoredItems ({ dispatch }, items = []) {
    items.forEach(item => dispatch('updateStoredItem', item))
  },
}


const mutations = {
  /** @see utils.mutations.update */
  update (state, payload) {
    utils.mutations.update(state, payload)
  },

  /** @see utils.mutations.reset */
  reset (_state_, payload) {
    utils.mutations.reset(_state_, { ...payload, origin: state() })
  },
}


export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
